export default __webpack_public_path__ + "static/media/J730_RoHS.b1b9f80d.pdf";